import { render, staticRenderFns } from "./CrmFileUploadButton.vue?vue&type=template&id=3c52d07d&scoped=true&lang=pug&"
import script from "./CrmFileUploadButton.vue?vue&type=script&lang=js&"
export * from "./CrmFileUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./CrmFileUploadButton.vue?vue&type=style&index=0&id=3c52d07d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c52d07d",
  null
  
)

export default component.exports